import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, CustomInput, Form, FormGroup, Input, Label } from "reactstrap";
import withRedirect from "../../hoc/withRedirect";

const RegistrationForm = ({ setRedirect, setRedirectUrl, layout, hasLabel }) => {
  // State
  const [plan, setPlan] = useState(false);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [address, setAddress] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [websiteURL, setWebsiteURL] = useState("");
  const [referredBy, setReferredBy] = useState("");
  const [purposeForApps, setPurposeForApps] = useState("");
  const [isAccepted, setIsAccepted] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);

  // Handler
  const handleSubmit = e => {
    e.preventDefault();
    toast.success(`Successfully registered as ${fullName}`);
    setRedirect(true);
  };

  useEffect(() => {
    setRedirectUrl("/authentication/login");
  }, [setRedirectUrl, layout]);

  useEffect(() => {
    setIsDisabled(!plan || !fullName || !email || !password || !confirmPassword || 
      !address|| !mobileNo|| !phoneNo|| !country|| 
      !state|| !city || !zipCode|| !websiteURL||
       !purposeForApps || !isAccepted || password !== confirmPassword);
  }, [plan,fullName, email, password, confirmPassword ,address, mobileNo,
     phoneNo, country,state, city, zipCode, websiteURL,purposeForApps, isAccepted]);

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup>
    <Label>You have selected Sikka API for</Label>
    <Input type="select" selected={plan}
        onChange={({ target }) => setPlan(target.selected)}>
      <option>Startup</option>
      <option>Silver</option>
      <option>Gold</option>
      <option>Platinum</option>
    </Input>
  </FormGroup>
      <FormGroup>
        {hasLabel && <Label>Full Name</Label>}
        <Input placeholder={!hasLabel ? "Full Name" : ""} value={fullName} onChange={({ target }) => setFullName(target.value)} />
      </FormGroup>
      <FormGroup>
        {hasLabel && <Label>Email address</Label>}
        <Input
          placeholder={!hasLabel ? "Email address" : ""}
          value={email}
          onChange={({ target }) => setEmail(target.value)}
          type="email"
        />
      </FormGroup>
      <div className="form-row">
        <FormGroup className="col-6">
          {hasLabel && <Label>Password</Label>}
          <Input
            placeholder={!hasLabel ? "Password" : ""}
            value={password}
            onChange={({ target }) => setPassword(target.value)}
            type="password"
          />
        </FormGroup>
        <FormGroup className="col-6">
          {hasLabel && <Label>Confirm Password</Label>}
          <Input
            placeholder={!hasLabel ? "Confirm Password" : ""}
            value={confirmPassword}
            onChange={({ target }) => setConfirmPassword(target.value)}
            type="password"
          />
        </FormGroup>
      </div>
      <FormGroup>
        {hasLabel && <Label>Address</Label>}
        <Input
          placeholder={!hasLabel ? "Address" : ""}
          value={address}
          onChange={({ target }) => setAddress(target.value)}
        />
      </FormGroup>
      <div className="form-row">
        <FormGroup className="col-6">
          {hasLabel && <Label>Mobile No</Label>}
          <Input
            placeholder={!hasLabel ? "Mobile No" : ""}
            value={mobileNo}
            onChange={({ target }) => setMobileNo(target.value)}
          />
        </FormGroup>
        <FormGroup className="col-6">
          {hasLabel && <Label>Phone No</Label>}
          <Input
            placeholder={!hasLabel ? "Phone No" : ""}
            value={phoneNo}
            onChange={({ target }) => setPhoneNo(target.value)}
          />
        </FormGroup>
      </div>
      <div className="form-row">
        <FormGroup className="col-6">
          {hasLabel && <Label>Country</Label>}
          <Input
            placeholder={!hasLabel ? "Country" : ""}
            value={country}
            onChange={({ target }) => setCountry(target.value)}
          />
        </FormGroup>
        <FormGroup className="col-6">
          {hasLabel && <Label>State</Label>}
          <Input
            placeholder={!hasLabel ? "State" : ""}
            value={state}
            onChange={({ target }) => setState(target.value)}
          />
        </FormGroup>
      </div>

      <div className="form-row">
        <FormGroup className="col-6">
          {hasLabel && <Label>City</Label>}
          <Input
            placeholder={!hasLabel ? "City" : ""}
            value={city}
            onChange={({ target }) => setCity(target.value)}
          />
        </FormGroup>
        <FormGroup className="col-6">
          {hasLabel && <Label>Zip Code</Label>}
          <Input
            placeholder={!hasLabel ? "Zip Code" : ""}
            value={zipCode}
            onChange={({ target }) => setZipCode(target.value)}
          />
        </FormGroup>
      </div>

      <FormGroup>
        {hasLabel && <Label>Website URL</Label>}
        <Input
          placeholder={!hasLabel ? "Website URL" : ""}
          value={websiteURL}
          onChange={({ target }) => setWebsiteURL(target.value)}
        />
      </FormGroup>
      <FormGroup>
        {hasLabel && <Label>Referred By</Label>}
        <Input
          placeholder={!hasLabel ? "Referred By" : ""}
          value={referredBy}
          onChange={({ target }) => setReferredBy(target.value)}
        />
      </FormGroup>
      <FormGroup>
        {hasLabel && <Label>Purpose for Apps </Label>}
        <Input
          placeholder={!hasLabel ? "Purpose for Apps" : ""}
          value={purposeForApps}
          onChange={({ target }) => setPurposeForApps(target.value)}
        />
      </FormGroup>
      <CustomInput
        id="customCheckTerms"
        label={
          <Fragment>
            I accept the <Link to="#!">terms</Link> and <Link to="#!">privacy policy</Link>
          </Fragment>
        }
        checked={isAccepted}
        onChange={({ target }) => setIsAccepted(target.checked)}
        type="checkbox"
      />
      <FormGroup>
        <Button color="primary" block className="mt-3" disabled={isDisabled}>
          Register
        </Button>
      </FormGroup>
    </Form>
  );
};

RegistrationForm.propTypes = {
  setRedirect: PropTypes.func.isRequired,
  setRedirectUrl: PropTypes.func.isRequired,
  layout: PropTypes.string,
  hasLabel: PropTypes.bool
};

RegistrationForm.defaultProps = {
  layout: "basic",
  hasLabel: false
};

export default withRedirect(RegistrationForm);
